import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Coffee, ChevronRight } from "lucide-react";
import api from "@/lib/api";

export default function CasualSessionsCard() {
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/casual/sessions/mine").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
  if (!rows || !rows.length) return null;
  return (
    <div className="rounded-2xl glow-border p-5" style={{ background: "var(--surface)" }} data-testid="casual-sessions-card">
      <div className="font-display font-bold flex items-center gap-2"><Coffee className="w-4 h-4 text-primary-c" /> Casual Play sessions</div>
      <p className="text-sm mt-1" style={{ color: "var(--text-2)" }}>Rate the players you met in published Open Play sessions — once per player per session.</p>
      <div className="mt-3 divide-y" style={{ borderColor: "var(--border)" }}>
        {rows.slice(0, 8).map((s) => (
          <button key={s.session_id} data-testid={`casual-session-${s.session_id}`} onClick={() => nav(`/casual/${s.session_id}`)} className="w-full py-2.5 flex items-center gap-2 text-sm text-left">
            <span className="font-semibold flex-1 truncate">{s.name}</span>
            <span className="text-xs mono" style={{ color: "var(--text-2)" }}>{s.date}{s.is_host ? " · host" : ""}</span>
            {s.to_rate > 0 && <span className="text-[10px] mono font-bold rounded-full px-2 py-0.5" style={{ background: "var(--primary)", color: "var(--on-primary)" }}>{s.to_rate} to rate</span>}
            <ChevronRight className="w-4 h-4" style={{ color: "var(--text-2)" }} />
          </button>
        ))}
      </div>
    </div>
  );
}
